const plans = [
  {
    title: "Turbo Connect",
    amount: "76,000",
    speed: "Up to 50Mbps",
    plan: "Tizeti Turbo Connect",
    price: "76000",
    slug: "turbo_connect",
    border: "#ff8c00",
    featured: false,
    description:
      "Fast and reliable internet for everyday use. Stream, browse and connect without limits on our Tizeti Turbo Connect plan.",
  },
  {
    title: "Turbo Connect Pro",
    amount: "120,000",
    speed: "Up to 70Mbps",
    plan: "Tizeti Turbo Connect Pro",
    price: "120000",
    slug: "turbo_connect_pro",
    border: "#17c3b2",
    featured: true,
    description:
      "Powerful internet for heavy usage. Experience top-notch speed and unlimited possibilities with our Tizeti Turbo Connect Pro package",
  },
  {
    title: "Turbo Connect Ultra",
    amount: "180,000",
    speed: "Up to 100Mbps",
    plan: "Tizeti Turbo Connect Ultra",
    price: "180000",
    slug: "turbo_connect_ultra",
    border: "#4f46e5",
    featured: false,
    description:
      "Premium internet performance for business and power users. Experience exceptional speed, stability, and reliability with our highest-tier package.",
  },
];

export default plans;
